<template>
  <div class="login">
    <img src="../../public/images/fondoNormal.jpg" class="fondo" alt="">
    <!--<h1 class="title">Ingreso a Reportes Personalizados</h1>-->
    <form action class="form" @submit.prevent="obtenerSesion()">
      <img class="logosimbolo" src="../../public/images/Logotipo-GeoVoy.png">
      <label v-if="bol === 1" style="color:#FF0000" class="form-label mensajeError" for="#text">Usuario no permitido:</label>
      <label v-else-if="bol === 2" style="color:#FF0000" class="form-label mensajeError" for="#text">Usuario o contraseña mal escrito:</label>
      <br>
      <br>
      <div class="divEmail">
        <div class="divPassLabel">
          <label class="form-label" for="#email">E-mail:</label>
        </div>
        <div class="divPassInput">
          <input class="form-input marginAuto" type="email" id="email" required placeholder="Escriba el correo" v-model="email" />
        </div>
      </div>
      <div class="divPass" v-show="true">
        <div class="divPassLabel">
          <label class="form-label" for="#password">Contraseña:</label>
        </div>
        <div class="divPassInput">
          <div class="password-input-wrapper">
            <input class="form-input" type="password" id="password" placeholder="Contraseña de acceso" v-model="password" :type="showPassword ? 'text' : 'password'" />
            <span class="password-icon" @click="toggleShowPassword()">
              <i class="far" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </span>
          </div>
        </div>
      </div>

      <input class="form-submit" type="submit" value="Ingresar" />
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bol: 0,
      email: '',
      password: '',
      aleatorio: 1379248,
      test: [],
      showPassword: false,
    };
  },
  created() {
    this.$root.$on('errorLogin', (el) => {
      this.test = el;
    });
  },
  watch: {
    '$root.test': {
      handler: function (e) {
        if (e) {
          if (e.length > 0) {
            this.bol = e[0];
            this.email = e[1];
            this.password = e[2];
          }
        }
      },
      immediate: true,
    }
  },
  methods: {
    obtenerSesion() {
      this.$router.push({ name: 'ComponentLogin', params: { user: this.email, password: this.password } });
    },
     toggleShowPassword() {
    
      this.showPassword = !this.showPassword;
    },
  },
  
  //mounted() {
  //  if (localStorage.aleatorio) {
  //    this.aleatorio = localStorage.aleatorio;
  //  }
  //},
  //watch: {
  //  aleatorio(newEmail) {
  //    localStorage.aleatorio = newEmail;
  //  }
  //}
}
</script>



<style lang="scss" scoped>
@import "~@fortawesome/fontawesome-free/css/all.css";

/* Estilos del componente */

.password-input-wrapper {
  position: relative;
}

.password-icon {
  position: absolute;
  top: 45%;
  right:65px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 1;
}

.password-icon i {
  font-size: 16px;
  color: #888;
}

/* Ajustes adicionales para corregir la posición del icono */

/*
.fondo{
  background: url("../../public/images/fondoNormal.jpg") center center / cover no-repeat rgb(6, 27, 97);
}
.login {
  padding: 2rem;
}

.title {
  text-align: center;
}

.form {
  margin: 3rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 20%;
  min-width: 350px;
  max-width: 100%;
  background: rgba(19, 35, 47, 0.9);
  border-radius: 5px;
  padding: 40px;
  box-shadow: 0 4px 10px 4px rgba(0, 0, 0, 0.3);
}

.form-label {
  margin-top: 2rem;
  color: white;
  margin-bottom: 0.5rem;

  &:first-of-type {
    margin-top: 0rem;
  }
}

.form-input {
  padding: 10px 15px;
  background: none;
  background-image: none;
  border: 1px solid white;
  color: white;

  &:focus {
    outline: 0;
    border-color: #1ab188;
  }
}

.form-submit {
  background: #1ab188;
  border: none;
  color: white;
  margin-top: 3rem;
  padding: 1rem 0;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #0b9185;
  }
}*/
/*inicia estilos nuevos*/
body{
  background-image: url(../../public/images/fondoNormal.jpg);
  

}


body .fondo{
  z-index: -1;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: absolute;
  top:0px;
  left:0px;
  width: 100%;
  height: 100%;
}
@media (min-width: 1300px){
  .fondo{
    background-size: 100%;
  }
}
.login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  //background-image: url('../../public/images/login.png');
  background-repeat: no-repeat;
  background-position: center;
  height: 600px;

}

.title {
  text-align: center;
  color: white;
  font-size: 28px;
}

.subtitulo {
  color: white;
  text-align: center;
  font-size: 15px;
}

.titulosPequenios {
  color: white;
  text-align: center;
  font-size: 14px;
}

.form {
  background-image:url(../../public/images/fondoLogin.png);
  background-size: 100% 100%;
  margin: 3rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 20%;
  min-width: 420px;
  height: auto;
  max-width: 100%;
  //background: rgba(43, 40, 105, 0.6);
  border-radius: 10px;
  border-width: 10px;
  box-shadow: 0 4px 10px 4px rgba(245, 177, 66, 0.9);

}

.form-label {
  margin-top: 2rem;
  margin-right: 0px;
  color: white;
  margin-bottom: 0.5rem;
  font-weight: bold;
  &:first-of-type {
    margin-top: 0rem;
  }
}

.form-input {
  padding: 10px 15px;
  margin: auto;
  margin-bottom: 5px;
  background: white;
  background-image: none;
  border-radius: 5px;
  width: 250px;
  height: 40px;
  border: 1px solid gray;
  color: #020135;

  &:focus {
    outline: 0;
    border-color: #1ab188;
  }
}

.form-submit {
  margin-left: 67%;
  margin-top: 10px;
  margin-bottom: 40px;
  background: #F5B142;
  border: none;
  font-weight: bold;
  border-radius: 5px;
  height: 40px;
  width: 100px;
  text-align: center;
  font-style: bold;
  vertical-align: middle;
  color: black;
 
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #ffb133;
  }
}

.logosimbolo {
  margin: auto;
  width: 70%;
  height: 32%;
  display: block;
  padding: 20px;
}

.iconos {
  margin: auto;
  width: 70%;
  height: 20%;
  display: block;
  padding: 5px;
}

.logouser {
  margin: auto;
  width: 18%;
  height: 14%;
  display: block;
}

.links {
  align-items: center;
  justify-content: center;
  text-align: center;
}

.version {
  color: #f3f3f3;
  font-size: 12px;
  text-align: center;
}
.marginAuto{
  margin: auto;
}
.divEmail{
  margin-left: 71px;
  margin-bottom: 10px;
}
.divPass{
  margin-left: 30px;
}
.divPassLabel{
  margin: auto;
  float: left;
}
.divPassInput{
  right: 50%;
}
.mensajeError{
  text-align: center;
  padding-left: 30px;
}
</style>
